class ModalTrigger extends ViewBasic {
	constructor(options) {
		super(options);

		//set default variables
		this.name = this.$el.attr('data-modal-name');
	}

	init() {
		this.addEvents();
	}

	addEvents() {
		this.$el.on('click', (e)=>this.clickHandler(e));
	}

	removeEvents() {
		this.$el.off('click', (e)=>this.clickHandler(e));
	}

	clickHandler(e){
		e.preventDefault();
		Me.dispatch.emit('modal-trigger', this, {name: this.name});
	}

	terminate(){
		this.removeEvents();
	}
}